var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home fill-height pa-2"},[_c('amplify-authenticator'),_c('list-of-projects'),_c('guidance-button',{attrs:{"page":"dashboard"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }